import { render, staticRenderFns } from "./ReportJ.vue?vue&type=template&id=bb4641ee&scoped=true&"
import script from "./ReportJ.vue?vue&type=script&lang=js&"
export * from "./ReportJ.vue?vue&type=script&lang=js&"
import style0 from "./ReportJ.vue?vue&type=style&index=0&id=bb4641ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4641ee",
  null
  
)

export default component.exports